import isInKwaiying from '../isInKwaiying';
import callNative from '../callNative';
import isIphone from '../isIphone';
function _open(url) {
    var a = document.createElement('a');
    a.style.display = 'none';
    a.setAttribute('href', url);
    document.body.appendChild(a);
    a.click();
    a.remove();
}
export default async function (url, _OpenOptions) {
    if (isInKwaiying()) {
        if (isIphone()) {
            _open(url);
            return;
        }
        return callNative('open', {
            isPromise: false,
            params: {
                url,
                showTopBar: _OpenOptions?.showTopBar || false,
                type: _OpenOptions?.type || 1,
                title: _OpenOptions?.title || '',
                bgColor: _OpenOptions?.bgColor || '#141414',
            },
        });
    }
    return _open(url);
}
